module.exports = __webpack_public_path__ + "static/media/logo_blue.85bcca2c.png";